import type { DropDownResult } from '@myosh/odin-components';
import { OdinCalendar } from '@myosh/odin-components';
import { useEffect, useState } from 'react';
import {
  apiDateFormat,
  formatDateAppendComparision,
  formatFromDate,
  getAssignedDatesFromFilter,
} from '../../helpers/dateFormater';
import type { CustomFiltersType } from '../../redux/config/CustomFiltersApi';

type CustomDateFieldRangeType = CustomFiltersType & {
  handleCustomFiltersChange: (value: DropDownResult[]) => void;
};

export default function CustomDateFieldRange({
  field,
  currentValues,
  handleCustomFiltersChange,
}: CustomDateFieldRangeType) {
  const [dates, setDates] = useState<Date[] | null>(null);

  /**
   * `currentValues` contain values returned from the backend.
   */
  useEffect(() => {
    if (currentValues && currentValues.length === 2) {
      const assignedValues = getAssignedDatesFromFilter(currentValues);
      const start = assignedValues[0];
      const end = assignedValues[1];
      setDates([formatFromDate(start, apiDateFormat), formatFromDate(end, apiDateFormat)]);
    } else {
      setDates(null);
    }
  }, [currentValues]);

  const handleChange = (value?: Date | Date[] | null) => {
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      setDates(value);
      const startDate = formatDateAppendComparision(value[0], true);
      const endDate = formatDateAppendComparision(value[1], false);
      handleCustomFiltersChange([
        { value: startDate, text: startDate },
        { value: endDate, text: endDate },
      ]);
    } else if (!value) {
      setDates(null);
      handleCustomFiltersChange([]);
    }
  };

  return (
    <div className="my-1">
      <OdinCalendar
        label={field}
        labelStyles="font-bold text-xs text-gray-1 font-bold px-1"
        value={dates}
        onChange={handleChange}
        selectionMode="range"
        readOnlyInput
        showButtonBar
        appendTo={document.body}
      />
    </div>
  );
}
